import { AlertTriangle, Clock } from "lucide-react";

const DAYS = 2;
const daysAgo = (iso) => (Date.now() - new Date(iso).getTime()) / 86400000;

// Enquiries older than two days that Robert has not marked as replied
export const OwnerOverdueBanner = ({ enquiries, onMarkReplied }) => {
  const overdue = enquiries.filter((e) => !e.replied && daysAgo(e.created_at) >= DAYS);
  if (!overdue.length) return null;

  return (
    <div className="bg-[#FFF8E6] border border-[#E4C67A] rounded-md p-5 mb-6" data-testid="owner-overdue-banner">
      <div className="flex gap-3">
        <Clock size={18} className="text-[#B08A3E] shrink-0 mt-0.5" />
        <div className="min-w-0 w-full">
          <h3 className="text-sm font-medium text-[#0F2A52]">
            {overdue.length} enquiry{overdue.length > 1 ? " is" : " is"} still waiting for a reply
          </h3>
          <p className="text-xs text-neutral-600 mt-1.5 leading-relaxed">
            These came in more than {DAYS} days ago. Reply, then mark them replied so the reminders stop.
          </p>
          <ul className="mt-3 space-y-2">
            {overdue.map((e) => (
              <li
                key={e.id}
                className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-[#0F2A52]"
                data-testid={`owner-overdue-${e.id}`}
              >
                <strong>{e.name}</strong>
                <span className="text-neutral-500">{e.property_name || "General enquiry"}</span>
                <span className="text-neutral-500">waiting {Math.floor(daysAgo(e.created_at))} days</span>
                <button
                  onClick={() => onMarkReplied(e)}
                  className="underline hover:no-underline text-[#B08A3E]"
                  data-testid={`owner-overdue-done-${e.id}`}
                >
                  Mark replied
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

// Warns the owner when an enquiry arrived but the notification email could not be delivered
export const OwnerAlertBanner = ({ enquiries }) => {
  const failed = enquiries.filter((e) => e.notified === false);
  if (!failed.length) return null;

  return (
    <div
      className="bg-red-50 border border-red-300 rounded-md p-5 mb-6"
      data-testid="owner-alert-banner"
    >
      <div className="flex gap-3">
        <AlertTriangle size={18} className="text-red-600 shrink-0 mt-0.5" />
        <div className="min-w-0">
          <h3 className="text-sm font-medium text-red-900">
            {failed.length} enquiry{failed.length > 1 ? " emails were" : " email was"} not delivered
          </h3>
          <p className="text-xs text-red-800/90 mt-1.5 leading-relaxed">
            These enquiries arrived on the website and are safely saved below, but the alert email could not
            be sent — so check this list against your inbox before replying.
          </p>
          <ul className="mt-3 space-y-1.5">
            {failed.map((e) => (
              <li key={e.id} className="text-xs text-red-900" data-testid={`owner-failed-alert-${e.id}`}>
                <strong>{e.name}</strong> · {e.property_name || "General enquiry"} ·{" "}
                {new Date(e.created_at).toLocaleDateString("en-AU", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OwnerAlertBanner;
